var map = {
	"./beast-tyrant.png": "5249",
	"./berserker.png": "60e5",
	"./brute.png": "919a",
	"./cragheart.png": "ee45",
	"./doomstalker.png": "bea2",
	"./elementalist.png": "ce6e",
	"./logo.png": "cf05",
	"./mindthief.png": "3604",
	"./nightshroud.png": "e327",
	"./plagueherald.png": "25f0c",
	"./quartermaster.png": "6850",
	"./sawbones.png": "f255",
	"./scoundrel.png": "61f5",
	"./soothsinger.png": "c32d",
	"./spellweaver.png": "0161",
	"./summoner.png": "2928",
	"./sunkeeper.png": "ce4f",
	"./tinkerer.png": "e99b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";